export const ProgressionMetrics = ["effort", "distance"];
export const SupportMetrics = ["pace", "heartrate"];
